import React from 'react';
import {StudentResume} from 'src/components/Resume/format-student-for-resume';
import {Text, View} from '@react-pdf/renderer';
import {createPlainResumeHeaderStyles} from 'src/components/Resume/styles';

interface Props {
  studentInfo: StudentResume;
}

function BWResumeHeader({studentInfo: student}: Props) {
  const styles = createPlainResumeHeaderStyles();
  let academicInterests = student.academicInterests;
  let academicInterestPrefix = 'Interests';

  if (student.intendedMajor) {
    academicInterests = [student.intendedMajor];
    academicInterestPrefix = 'Intended Major';
  }

  return (
    <View>
      <View style={styles.headerContainer}>
        <View style={styles.infoContainer}>
          <Text style={styles.nameText}>{student.name}</Text>
          <View>
            <Text style={styles.contactText}>{student.contactInformation}</Text>
            {academicInterests.length > 0 ? (
              <Text style={styles.infoText}>{`${academicInterestPrefix}: ${academicInterests.join(
                ', '
              )}`}</Text>
            ) : null}
          </View>
        </View>
      </View>
    </View>
  );
}

export default BWResumeHeader;
